import { DefaultOnboardingRoutes, SignInOnboardingExtraRoutes } from 'apps/customer/routes/paths';

import { OnboardingStep } from './OnboardingStep';

export const STEPPER_VISIBLE_STEPS = new Set<OnboardingStep>([
  OnboardingStep.AddVehicle,
  OnboardingStep.AddPayment,
  OnboardingStep.AddEmail,
]);

export const PATH_FOR_STEP: Record<OnboardingStep, string> = {
  [OnboardingStep.Landing]: DefaultOnboardingRoutes.SignIn,
  [OnboardingStep.VerifyPhone]: DefaultOnboardingRoutes.Verify,
  [OnboardingStep.AddVehicle]: DefaultOnboardingRoutes.Vehicle,
  [OnboardingStep.AddPayment]: DefaultOnboardingRoutes.PaymentMethod,
  [OnboardingStep.AddEmail]: DefaultOnboardingRoutes.AddEmail,
  [OnboardingStep.ReviewSubscription]: SignInOnboardingExtraRoutes.ReviewSubscription,
  [OnboardingStep.Success]: SignInOnboardingExtraRoutes.Complete,
};

const STEP_FOR_PATH = new Map(
  Object.entries(PATH_FOR_STEP).map(([step, path]) => [path, step as OnboardingStep]),
);

export function stepForPath(pathname: string): OnboardingStep | null {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return STEP_FOR_PATH.get(normalizedPath) ?? null;
}
